import { Profile } from 'models'
import Constants from 'api-constants'

/**
 * Create internal account from Backend metadatas
 * @doc https://docs.nagra.com/doc/otv/otvdoc2051/apis/account-and-device-manager-adm-api-documentation#/User%20Accounts%20Service%20(OPF%20Specific)/getAccountByTokenHeader
 * @param {Object} account
 * @returns {Profile}
 */
export const profileFactory = (account, config = {}) => {
    const {
        status: nagraStatus,
        accountProfileId,
        accountNumber,
        externalId,
        accountProfile,
        pvrStatus,
        homeIpAddress,
        geoBlockExempt,
        signonId,
    } = account || {}

    let status
    switch (nagraStatus) {
        case 'RESTRICTED': // The account can only browse content and may not playback.
            status = Profile.STATUS.PLAYBACK_RESTRICTED
            break
        case 'SUSPENDED': // The account can not sign-on or use the system.
            status = Profile.STATUS.SUSPENDED
            break
        case 'CANCELLED': // The account has been cancelled (this status is permanent).
            status = Profile.STATUS.DEACTIVATED
            break
        case 'ACTIVE': // The account can use the system to browse and playback entitled content
        default:
            status = Profile.STATUS.ACTIVATED
            break
    }

    return new Profile({
        userId: accountNumber,
        username: accountNumber,
        customerId: externalId,
        profileId: accountProfileId,
        pcLevel: config.defaultUserPcLevel,
        dvrEnabled: pvrStatus === 'ENABLED',
        dvrQuota: 0,
        dvrQuotaRemaining: 0,
        dvrQuotaUnit: Profile.DVR_QUOTA_UNIT.HOUR,
        status,
        // For the SagemCom board and open device, OTT for now
        tvProfile: Constants.eligibility.OTT,
        // For now as we don't know how to do which those fields, put them here in the dynamic area
        namedProperties: {
            TVID: accountNumber,
            accountProfile,
            pvrStatus,
            homeIpAddress,
            geoBlockExempt,
            signonId,
            externalId,
        },
    })
}
